function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2215",
  "data-name": "Group 2215",
  opacity: 0.697
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_33",
  "data-name": "Ellipse 33",
  cx: 7.018,
  cy: 7.018,
  rx: 7.018,
  ry: 7.018,
  transform: "translate(6.489)",
  fill: "#a2a2a2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Union_28",
  "data-name": "Union 28",
  d: "M0,10.384V6.414L.33,6.3C.105,6.277-.01,6.258,0,6.245A17.034,17.034,0,0,1,13.451,0,17.522,17.522,0,0,1,27.01,6.36a.133.133,0,0,1,.029.054h0v.019s0,0,0,0v3.95Z",
  transform: "translate(0 16.105)",
  fill: "#a2a2a2"
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.041,
    height: 26.489,
    viewBox: "0 0 27.041 26.489",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.b0937045.svg";
export { ForwardRef as ReactComponent };